module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty17.9f18f638.jpg";